// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3D7Mp","modalForm":"UpgradeEpcsModal_modalForm__33GL4","modalFooter":"UpgradeEpcsModal_modalFooter__1lFQA"};